var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isSignedIn)?_c('b-button',{attrs:{"variant":"outline-dark"},on:{"click":function($event){return _vm.onLoginClick()}}},[_vm._v("Sign in")]):_vm._e(),(_vm.isSignedIn)?_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":function($event){return _vm.onLogoutClick()}}},[_vm._v("Sign out")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }